import { render } from "./KubernetesResourceLimit.vue?vue&type=template&id=0548d30c"
import script from "./KubernetesResourceLimit.vue?vue&type=script&lang=js"
export * from "./KubernetesResourceLimit.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__